<!-- <p-growl #growl [baseZIndex]="9999999" [(value)]="growlMessage" [immutable]="false" [sticky]="false" [life]="5000">
</p-growl> -->
<p-toast></p-toast>

<div id="main" class="wrapper">
   
    <app-main-header-component *ngIf="!isCustomerRatingUrl"></app-main-header-component>

    <mat-progress-bar *ngIf="loading" mode="indeterminate">
    </mat-progress-bar>
    <div>
        <!-- class="BackImg" -->
        <div class="temp-sibiling" *ngIf="toggleFullWidth"></div>
        <div class="StaticBack" [class.no-min-height]="isCustomerRatingUrl">
            <div class="row">
                <div class="col-xs-12">
                    <app-alert-component class="alertInfo"></app-alert-component>
                    <app-recieve-call-alert-component class="alertCallInfo"></app-recieve-call-alert-component>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="!isSuccessOrFailUpaymentUrl && !isCustomerRatingUrl">
<app-footer-component class="footer"></app-footer-component>
</ng-container> 